module.exports = __webpack_public_path__ + "img/software-shape.99a4718b.png";